module.exports = __webpack_public_path__ + "static/media/phone.ffedbd03.svg";